/**
 * @graph-stack mall
 * @graph-domain Operations
 * @graph-business TanStack Queryキー定義。auth/scoring/masterの階層的クエリキーでキャッシュ管理
 * @graph-connects none
 */
export const queryKeys = {
  auth: {
    all: ['auth'] as const,
    me: () => [...queryKeys.auth.all, 'me'] as const,
  },
  scoring: {
    all: ['scoring'] as const,
    history: (limit?: number) => [...queryKeys.scoring.all, 'history', limit] as const,
    detail: (id: string) => [...queryKeys.scoring.all, 'detail', id] as const,
  },
  master: {
    all: ['master'] as const,
    brands: () => [...queryKeys.master.all, 'brands'] as const,
    categories: () => [...queryKeys.master.all, 'categories'] as const,
    brandLines: () => [...queryKeys.master.all, 'brandLines'] as const,
  },
} as const;
